var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      staticStyle: { overflow: "auto", "margin-top": "100px" },
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_RuleSettings"),
        width: "620px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "main-content",
          staticStyle: { height: "300px", overflow: "auto" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "502px", "margin-top": "10px" },
              attrs: { "label-width": "130px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_ApplicationScope") } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { "padding-left": "2px" },
                          attrs: { disabled: _vm.readonly },
                          model: {
                            value: _vm.form.useHqSet,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "useHqSet", $$v)
                            },
                            expression: "form.useHqSet"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings"))
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "10px" } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { width: "502px" },
                    attrs: {
                      "label-width": "130px",
                      disabled: _vm.form.useHqSet && _vm.branchId !== 1
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("CargoMsg.Cargo_PreApproval") }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.preApproval,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "preApproval", $$v)
                              },
                              expression: "form.preApproval"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_OperationReview"))
                              )
                            ]),
                            _vm.showDeptReview
                              ? _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_DepartmentReview")
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _c("el-radio", { attrs: { label: 3 } }, [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_FinanceApproval"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SystemMaintenance.ServiceScenarioApplication"
                          )
                        }
                      },
                      [
                        _c("specific-business-rule-dialog", {
                          staticStyle: { width: "350px" },
                          attrs: {
                            "input-width": "100%",
                            lob: _vm.lob,
                            "apply-ui-custom": true,
                            "specific-business-rule-uuid":
                              _vm.form.specificBusinessRuleUuid,
                            "specific-business-rules": _vm.specificBusinessRules
                          },
                          on: {
                            change: function(p) {
                              return _vm.specificBusinessRuleChange(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SystemMaintenance.SceneParameters")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "350px" },
                          attrs: { type: "textarea", rows: 5 },
                          model: {
                            value: _vm.form.ruleParam,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ruleParam", $$v)
                            },
                            expression: "form.ruleParam"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: { color: "#e6a23c", "font-size": "13px" }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_RuleBasedApproval")) +
                          " "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }